/**
 * UsersTab - User management tab component for the agent drawer
 *
 * Provides user management operations for Praetorian users.
 * Re-exports UserManagementTab content adapted for drawer context.
 */

import React from 'react';

import type { Agent } from '@/hooks/useAgents';
import { UserManagementTab } from '@/sections/agents/components/aegis-management/user/UserManagementTab';

interface UsersTabProps {
  agent: Agent;
  taskMonitoring: ReturnType<
    typeof import('@/sections/agents/hooks').useTaskMonitoring
  >;
  setSelectedTabValue: (value: string) => void;
  isDrawerOpen: boolean;
}

export const UsersTab: React.FC<UsersTabProps> = ({
  agent,
  taskMonitoring,
  setSelectedTabValue,
  isDrawerOpen,
}) => {
  return (
    <div className="flex h-full flex-col" data-testid="agent-drawer-users-tab">
      <UserManagementTab
        agent={agent}
        taskMonitoring={taskMonitoring}
        setSelectedTabValue={setSelectedTabValue}
        isModalOpen={isDrawerOpen}
      />
    </div>
  );
};
